import React from 'react'
import { RouterProvider } from 'react-router-dom'

import { useCanary } from '@bill/canary.react'

import { createApplicationRoutes } from './router'

export const App = () => {
  const showCreditAppDashboardRedesign = useCanary('rollout-credit-app-dashboard-redesign') as boolean

  return <RouterProvider router={createApplicationRoutes({ showCreditAppDashboardRedesign })} />
}

export default App
